export default function (options) {
  const customizeValue = options.value.formatY && (({ value }) => options.value.formatY(value))
  return {
    customizeValue,
  }
}
